(function () {
    'use strict';

    angular.module("imApp").factory("timeProjectsService", ['$ihttp', function ($ihttp) {
        let service = {
            listTimeProjects: function (parms) {
                return $ihttp.post({
                    method: 51,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
